import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export const Publications = ({ items }) => (
  <section id="press" className="bg-[#121110] text-[#EFEAE1] py-28 lg:py-36" data-testid="press-section">
    <div className="px-5 lg:px-10">
      <Reveal>
        <h2 className="font-giant text-[12vw] lg:text-[7.5vw] leading-[0.9]">
          IN THE PR<span className="font-swash text-[#A8512E] text-[10vw] lg:text-[6vw]">e</span>SS
        </h2>
        <p className="max-w-xl text-lg lg:text-xl leading-relaxed text-[#EFEAE1]/60 mt-8">
          Quiet work occasionally makes noise. Coverage and stories from the media —
          tap a publication's logo to read.
        </p>
      </Reveal>

      <div className="mt-16 border-t border-[#EFEAE1]/15">
        {items.map((pub, i) => (
          <Reveal key={pub.id} delay={(i % 2) * 0.08}>
            <article className="py-10 lg:py-12 border-b border-[#EFEAE1]/15 grid grid-cols-1 lg:grid-cols-12 gap-8" data-testid={`press-card-${i}`}>
              <div className="lg:col-span-8">
                <h3 className="font-semibold text-xl lg:text-3xl leading-snug" data-testid={`press-title-${i}`}>
                  {pub.title}
                </h3>
                {pub.text && <p className="text-[#EFEAE1]/60 leading-relaxed mt-4 max-w-2xl">{pub.text}</p>}
              </div>
              <div className="lg:col-span-4 flex flex-wrap items-start lg:justify-end gap-3">
                {(pub.links || []).map((link, j) => (
                  <a
                    key={link.url}
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group inline-flex items-center gap-3 rounded-full border border-[#EFEAE1]/25 bg-[#EFEAE1]/5 pl-2 pr-5 py-2 hover:border-[#A8512E] hover:bg-[#A8512E]/15 transition-colors duration-300"
                    data-cursor="view"
                    data-testid={`press-link-${i}-${j}`}
                  >
                    <span className="w-9 h-9 rounded-full bg-white flex items-center justify-center overflow-hidden shrink-0">
                      {link.logo ? (
                        <img src={link.logo} alt={link.source} className="w-6 h-6 object-contain" />
                      ) : (
                        <span className="font-giant text-sm text-[#121110]">{link.source?.[0]}</span>
                      )}
                    </span>
                    <span className="text-sm font-medium text-[#EFEAE1]/80 group-hover:text-[#EFEAE1] transition-colors duration-300">
                      {link.source}
                    </span>
                    <ArrowUpRight size={14} className="text-[#EFEAE1]/50 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                  </a>
                ))}
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Publications;
